export default {
  Negative: 'red.100',
  Positive: 'green.100',
  Neutral: 'yellow.100',
}
